var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('kpi-summary-search'),_c('div',{staticClass:"mx-auto w-75"},[_c('kpi-summary-chart',{attrs:{"height":200,"labels":_vm.labels,"datasets":_vm.datasets}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }